import { FC, useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { loadNpsScript } from '../services/npsService'

const Nps: FC = (): React.ReactElement => {
  useEffect(() => {
    loadNpsScript()
  }, [])

  return <Outlet />
}

export default Nps
